<template>
  <div v-if="ready" class="vue-list-filter">
    <div class="list-tools" style="margin-bottom:1.5rem">
      <div class="grid-x grid-padding-x">
        <div class="cell small-12">
          <form>
            <input 
              @input="debounceInput" 
              class="list-filter no-margin" 
              type="text" 
              placeholder="Filter by keyword" />
          </form>
        </div>
      </div>
    </div>

    <div 
      v-if="filteredList.length" 
      class="list-items">
      <div 
        :class="cssClasses"
        class="grid-x grid-padding-x">
        <div 
          v-for="(item, index) in filteredList" 
          :key="index" 
          class="cell">
          <transition name="fade">
            <div class="card padding" style="margin-bottom:1rem;border:0px;border-top:1px solid #eee">
              <p class="text-center no-margin">
                <a 
                  :href="item.link" 
                  :title="item.title" 
                  class="btn btn-clear btn-expanded"
                  style="margin-bottom:.5rem">
                  <strong>{{ item.title }}</strong>
                </a>
              </p>
              <h6 
                v-if="item.phone"
                class="text-center no-margin bold">
                <a 
                  :href="(item.tel_link ? item.tel_link : item.phone)">
                  {{ item.phone }}
                </a>
              </h6>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div v-else>
      <p v-if="list && text_filter != ''">Sorry, no matches found for the current input.</p>
    </div>
  </div>
</template>

<script>
import {_} from 'vue-underscore'
import { debounce } from 'debounce'

export default {
  name: 'App',
  data () {
    return {
      ready: false,
      options: false,
      filter_text: ''
    }
  },
  methods: {
    init () {
      this.ready = true
    },
    debounceInput: debounce(function (e) {
      this.filter_text = e.target.value
    }, 1000)
  },
  computed: {
    config () {
      return this.$options.config
    },
    cssClasses () {
      if ('classes' in this.config) {
        return this.config.classes
      }
      return false
    },
    list () {
      return this.config.list
    },
    filteredList () {
      const vm = this
      if (this.filter_text) {
        return _.filter(this.list, function(item) {
          const filter = vm.filter_text.toLowerCase()
          const title = item.title.toLowerCase()
          const tags = item.tags.toLowerCase()
          return (
            title.indexOf(filter) !== -1 || tags.indexOf(filter) !== -1
          )
        })
      } else {
        return this.list
      }
    }
  },
  mounted () {
    this.init()
  }
}
</script>
